var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 66 78",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3646 30.306L33.3019 2.97003L3.23926 30.306",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4859 39.2872L33.3006 57.6418L13.1152 39.2872V12.1378H53.4859V39.2872Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53.4859 39.2872L33.3006 57.6418L13.1152 39.2872V12.1378H53.4859V39.2872Z",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3646 30.3061V71.1595C63.3646 73.2848 61.6406 75.0088 59.5139 75.0088H7.08993C4.96326 75.0088 3.23926 73.2848 3.23926 71.1595V42.4421",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M62.6983 30.9103L33.3009 57.6423L3.23828 30.3063",
    stroke: "currentColor",
    strokeWidth: 4.75867,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7899 40.2837C26.7193 39.181 23.7246 35.4597 23.7246 31.0397C23.7246 25.7503 28.0126 21.4637 33.3006 21.4637C38.5899 21.4637 42.8779 25.7503 42.8779 31.0397C42.8779 35.505 39.8219 39.2557 35.6886 40.3157",
    stroke: "currentColor",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4661 33.548C36.4661 33.548 33.5501 36.316 30.1367 33.548",
    stroke: "currentColor",
    strokeWidth: 2.66667,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3979 28.8675C38.3979 29.7315 37.6979 30.4315 36.8339 30.4315C35.9699 30.4315 35.2686 29.7315 35.2686 28.8675C35.2686 28.0035 35.9699 27.3022 36.8339 27.3022C37.6979 27.3022 38.3979 28.0035 38.3979 28.8675Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3344 28.8675C31.3344 29.7315 30.6344 30.4315 29.7704 30.4315C28.9064 30.4315 28.2051 29.7315 28.2051 28.8675C28.2051 28.0035 28.9064 27.3022 29.7704 27.3022C30.6344 27.3022 31.3344 28.0035 31.3344 28.8675Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.81cdd65b9b5776ea8293d348cabf9589.svg";
export { ForwardRef as ReactComponent };